import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { symptoms } from "src/types";

const initialState: symptoms.SymptomsStateType = {
  symptoms: {
    data: null,
    isLoading: false,
    error: null,
  },
  pspSymptoms: {
    data: null,
    isLoading: false,
    error: null,
  },
};

const symptomsSlice = createSlice({
  name: "symptoms",
  initialState,
  reducers: {
    // get symptoms
    getSymptomsRequest: (
      state: symptoms.SymptomsStateType,
      action: PayloadAction<any>
    ) => {
      state.symptoms.isLoading = true;
      state.symptoms.data = null;
      state.symptoms.error = null;
    },
    getSymptomsSuccess: (
      state: symptoms.SymptomsStateType,
      action: PayloadAction<any>
    ) => {
      state.symptoms.isLoading = false;
      state.symptoms.data = action.payload;
      state.symptoms.error = null;
    },
    getSymptomsError: (
      state: symptoms.SymptomsStateType,
      action: PayloadAction<any>
    ) => {
      state.symptoms.isLoading = false;
      state.symptoms.data = null;
      state.symptoms.error = action.payload;
    },
    // get psp symptoms
    getPSPSymptomsRequest: (
      state: symptoms.SymptomsStateType,
      action: PayloadAction<any>
    ) => {
      state.pspSymptoms.isLoading = true;
      state.pspSymptoms.data = null;
      state.pspSymptoms.error = null;
    },
    getPSPSymptomsSuccess: (
      state: symptoms.SymptomsStateType,
      action: PayloadAction<any>
    ) => {
      state.pspSymptoms.isLoading = false;
      state.pspSymptoms.data = action.payload;
      state.pspSymptoms.error = null;
    },
    getPSPSymptomsError: (
      state: symptoms.SymptomsStateType,
      action: PayloadAction<any>
    ) => {
      state.pspSymptoms.isLoading = false;
      state.pspSymptoms.data = null;
      state.pspSymptoms.error = action.payload;
    },
  },
});

export const {
  // get symptoms
  getSymptomsRequest,
  getSymptomsSuccess,
  getSymptomsError,
  // get psp symptoms
  getPSPSymptomsRequest,
  getPSPSymptomsSuccess,
  getPSPSymptomsError,
} = symptomsSlice.actions;

export default symptomsSlice.reducer;
